import axios from 'axios';
import Cookies from "js-cookie";
import { Loading, Message, MessageBox} from 'element-ui';
import store from '../store/index';
import router from '../router/index';
import { sessionStorage,localStorage } from '../assets/js/storage';
import {apiConfig} from '../config/apiConfig';

// if (!store.state.token) {
//   let token = sessionStorage.getItem('token') || ''
//   store.commit('SET_TOKEN', sessionStorage.getItem('token'));  //token写入本地存储
// }


// axios 配置
const ajaxUrl = process.env.NODE_ENV === 'production' ? apiConfig.proApi + '/api' : '/api';
console.log('apiConfig',ajaxUrl)

const http = axios.create({
  baseURL: ajaxUrl,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
  },
  // transformRequest: [function (data, headers) {
  //   headers.token = sessionStorage.getItem('token');
  //   if (headers['Content-type'] === 'multipart/form-data') {
  //     return data;
  //   } else {
  //     return JSON.stringify(data);
  //   }
  // }]
});

let whiteList = ['/api/account/loginByPhone']

// 请求拦截器
http.interceptors.request.use(config => {
  // 开发环境下，如果请求是 post,put,patch,则打印数据体，方便调试
  config.headers['token'] = Cookies.get('token')||'';
  if (process.env.NODE_ENV === 'development') {
    const { method } = config;
    if (method === 'post' || method === 'put' || method === 'patch') {
      //console.log(config.data);
    }
  }

  return config;
}, error => {
  Message.error({
    message: '请求失败'
  });
  return Promise.reject(error);
});

// 响应拦截器
http.interceptors.response.use(res => {
  // 返回错误码
  console.log(res)
  if (res.data instanceof Blob) {
    return res;
  } else {
    if (res.data.success) {
      return res;
    } else {
      if (!res.config.headers.noMsg){
        Message.error(res.data.message);
      }
      if (res.data.code == 202 || res.data.code === 221 || res.data.message == '无权限' || res.data.message == 'Ticket 不可识别' || res.data.message == '用户凭证错误' || res.data.message == '账号登录过期'){
        Cookies.remove("token");
        localStorage.removeItem("user");
        router.replace({path: '/login'});
        this.$store.commit('SET_TOKEN', '');
        this.$store.commit('SET_USER', null);
      } else if (whiteList.find(item => res.config.url.indexOf(item) > -1)) {
        // 处理特殊情况
        return res
      }
      return false;
    }
  }

}, error => {
  Message.error('网络异常，请检查您的网络');
  return Promise.reject(error);
});

export default http;



// WEBPACK FOOTER //
// ./src/api/http.js